<template>
  <div>
    <p class="notification_label">This is a notification test</p>
  </div>
</template>

<script>
export default {
  name: "TestUserNotificationPhoneNumberNotification",
  props: {
    notification: Object
  },
}
</script>

<style lang="scss" scoped>
.notification_label {
  margin-bottom: 2px;
  font-size: 0.875rem;
}
</style>
